import { render, staticRenderFns } from "./PageLetbanePayment.vue?vue&type=template&id=beddb662&scoped=true&"
import script from "./PageLetbanePayment.vue?vue&type=script&lang=js&"
export * from "./PageLetbanePayment.vue?vue&type=script&lang=js&"
import style0 from "./PageLetbanePayment.vue?vue&type=style&index=0&id=beddb662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beddb662",
  null
  
)

export default component.exports